module.exports = __webpack_public_path__ + "media/basic-details/webinar@2x-34732492.png";